import Overlay from 'client/javascript/overlay';
import { verifyImgSrc } from 'shared/util/helpers';
import genericSvgString from 'client/images/icons/amenities/generic.svg';
import { trackInteraction, setupScrollAnalyticsTracking } from 'client/javascript/analytics';

const OPEN_AMENITIES_BTN_ID = 'open-amenities-btn';
const CLOSE_AMENITIES_BTN_ID = 'close-amenities-btn';
const AMENITIES_NODE_ID = 'amenities-full';

const amenitiesTrackingEvents = {
  open: () => {
    trackInteraction({
      label: 'Click View All Amenities Link'
    });
  },
  close: () => {
    trackInteraction({
      label: 'Click Close All Amenities Overlay'
    });
  },
  scroll: () => {
    setupScrollAnalyticsTracking({
      label: 'Scrolled to View All Amenities Link',
      selector: `#${OPEN_AMENITIES_BTN_ID}`
    });
  }
};

function setupAmenitiesEvents(amenitiesOverlay) {
  const openAmenitiesBtn = document.getElementById(OPEN_AMENITIES_BTN_ID);
  const closeAmenitiesBtn = document.getElementById(CLOSE_AMENITIES_BTN_ID);

  closeAmenitiesBtn.addEventListener('click', () => {
    amenitiesTrackingEvents.close();
    amenitiesOverlay.close();
  });

  if (openAmenitiesBtn) {
    openAmenitiesBtn.addEventListener('click', event => {
      event.preventDefault();
      amenitiesTrackingEvents.open();
      amenitiesOverlay.open();
    });
  }
  amenitiesTrackingEvents.scroll();
}

function setupAmenitiesFallbackIcon() {
  // data URI is used to avoid passing asset path from server
  const genericDataUrl = `data:image/svg+xml,${encodeURIComponent(genericSvgString)}`;
  const images = Array.from(document.querySelectorAll('.amenity-img'));
  images.forEach(img => {
    const resetInvalidSrc = exists => {
      if (!exists) {
        img.src = genericDataUrl; // eslint-disable-line
        img.classList.add('generic-icon');
      }
    };
    verifyImgSrc(img.src, resetInvalidSrc);
  });
}

export function setupAmenitiesOverlay() {
  const amenitiesNode = document.getElementById(AMENITIES_NODE_ID);

  const amenitiesOverlay = new Overlay(AMENITIES_NODE_ID, { excludeCloseButton: true });
  amenitiesOverlay.addContent(amenitiesNode);
  amenitiesNode.classList.remove('hidden');

  setupAmenitiesEvents(amenitiesOverlay);
  setupAmenitiesFallbackIcon();
}
